<template>
  <!-- 产品总支出 -->
  <div class="Producttotal">
    <h2>
      <span class="left"> {{ $fanyi("产品总支出") }}</span>
      <span class="right">${{
        $fun.EURNumSegmentation(props.pricedata?.sum_discount_price_dollar)
      }}(￥{{
  $fun.RMBNumSegmentation(props.pricedata?.sum_discount_price)
}})</span>
    </h2>
    <!-- 产品价值 -->
    <div class="item">
      <span class="left">{{ $fanyi("产品价值") }} </span>
      <span class="right">${{ $fun.EURNumSegmentation(props.pricedata?.goods_price_dollar) }} (￥{{
        $fun.RMBNumSegmentation(props.pricedata?.goods_price)
      }})</span>
    </div>

    <!-- 手续费  -->
    <div class="item">
      <span class="left">{{ $fanyi("佣金") }} ({{
        props.pricedata?.service_rate * 100
      }}
        %)</span>
      <span class="right">
        ${{
          $fun.EURNumSegmentation(
            props.pricedata?.old_service_rate_price_dollar
          )
        }}
        (￥{{
          $fun.RMBNumSegmentation(props.pricedata?.old_service_rate_price)
        }})</span>
    </div>
    <!-- 附加服务 -->
    <div class="item">
      <span class="left">{{ $fanyi("附加服务") }} </span>
      <span class="right">
        ${{ $fun.EURNumSegmentation(props.pricedata?.option_price_dollar) }} (￥{{
          $fun.RMBNumSegmentation(props.pricedata?.option_price)
        }})</span>
    </div>
    <!-- 其他服务 -->
    <div class="item">
      <span class="left"> {{ $fanyi("其他费用") }}</span>
      <span class="right">
        ${{ $fun.EURNumSegmentation(props.pricedata?.others_price_dollar) }} (￥{{
          $fun.RMBNumSegmentation(props.pricedata?.others_price)
        }})</span>
    </div>
  </div>
</template>
<script setup>
import { getCurrentInstance, defineProps } from "vue";

const { proxy } = getCurrentInstance();
console.log(proxy);
const props = defineProps({
  // 所有的价格
  pricedata: {
    type: Object,
    default: () => { },
  },
});
</script>
<style lang="scss" scoped="scoped">
@import "@/style/scss/mixin.scss";

.Producttotal {
  width: 100%;
  min-height: 199px;
  background: #ffffff;
  border-radius: 6px;
  margin-top: 10px;
  box-sizing: border-box;
  padding: 15px;
  border: 0.5px solid #e2e2e2;

  h2 {
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 18px;
    margin-bottom: 5px;

    .left {
      font-size: 12px;
      font-family: PingFang-SC-Semibold, PingFang-SC;
      font-weight: 600;
      color: #222222;
      line-height: 18px;
    }

    .right {
      font-size: 12px;
      font-family: Arial-BoldMT, Arial;
      font-weight: 600;
      color: #ff730b;
      line-height: 18px;
    }
  }

  .item {
    height: 33px;
    border-bottom: 1px dashed #dbdbdb;
    display: flex;
    justify-content: space-between;
    align-items: center;

    .left {
      font-size: 10px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #999999;
      line-height: 14px;
    }

    .right {
      font-size: 10px;
      font-family: ArialMT;
      color: #222222;
      line-height: 14px;
    }
  }
}
</style>
